(function () {
  var style = document.body.getAttribute('data-scroll-anim');
  if (!style) return;

  var sections = Array.from(
    document.querySelectorAll('#MainContent .shopify-section')
  );
  if (!sections.length) return;

  // Batch queue so stagger can sort by vertical position
  var queue = [];
  var qTimer = null;

  function flush() {
    queue.sort(function (a, b) {
      return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
    });
    queue.forEach(function (el, i) {
      var delay = style === 'stagger' ? i * 80 : 0;
      setTimeout(function () {
        el.classList.add('is-visible');
        el.style.transitionDelay = '';
      }, delay);
    });
    queue = [];
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          queue.push(entry.target);
          observer.unobserve(entry.target);
        }
      });
      clearTimeout(qTimer);
      qTimer = setTimeout(flush, 40);
    },
    { rootMargin: '0px 0px -80px 0px', threshold: 0.05 }
  );

  sections.forEach(function (el) {
    observer.observe(el);
  });
})();
